export default "__VITE_ASSET__CayAXxXj__"